
import {fadeIn, fadeOut} from './fade.js';

export default class {
    //星ボタンクリックのアクション

    
    
    constructor() {
        this.showedElm;
        this.overlay = document.getElementById('js-overlay');
        this.te = true;

        window.addEventListener('mouseup', (e) => {
            this.onClick(e)
        });
    }

    onClick(e) {
        const isShow = this.removeBaloon(e);
        //すでに表示されているものがあれば消してから処理
        if(isShow) {
            setTimeout(()=> {
                this.clickHandle(e);
                this.delayFadeOut(e);
            }, 300);
        } else {
            this.clickHandle(e);
            this.delayFadeOut(e);
        }
    }
    
    delayFadeOut(e) {
        if(this.showedElm && !$('#js-loading').hasClass('is-show')) {
            if(!this.showedElm.classList.contains('js-autohide')) {
                return false;
            }
            setTimeout(()=> {
                this.removeBaloon(e);
            }, 1000);
            return true;
        }
        return false;
    }

    clickHandle(e) {
        const target = e.target;
    
        if(target && !$('#js-loading').hasClass('is-show')) {
            const btn = target;
            if($(btn).hasClass('js-star')) {
                console.log(e);
                console.log(target)
                e.preventDefault();
                const showId = btn.getAttribute('data-test');
                const pos = this.getPos(btn);
                
                let showEl;
                
                if(showId) {
                    
                    if (!$(target).next().hasClass('p-mystar')) {
                       $('#js-loading').addClass('is-show');
                       this.te = false;
                       $('#j-container').addClass('is-show-popup');

                        if (showId =='js-mystar-notlogged')  {
                            $(btn).after('<div id="js-mystar-notlogged" class="p-mystar p-mystar-fix p-mystar--notlogged"><button class="p-mystar__close js-mystar-close"></button><dl><dt class="p-mystar__ttl"><b>ログインをしてお気に入り番組を登録しよう！</b></dt><dd class="p-mystar__txt">Myスカパー！にログインをすると、マイリストにお気に入り番組リストを作成することができます！</dd></dl><div class="p-mystar__wbtn"><a href="#" class="p-mystar__btn p-mystar__btn--login">ログイン</a><a href="#" class="p-mystar__btn">新規会員登録</a></div></div>');
                        } else if (showId =='js-mystar-over')  {
                            $(target).after('<div id="js-mystar-over" class="p-mystar p-mystar-fix p-mystar--over js-dautohide"><button class="p-mystar__close js-mystar-close"></button><dl><dt class="p-mystar__ttl"><b>マイリストに番組を登録できません</b></dt><dd class="p-mystar__txt">登録可能な番組件数を超えました。番組は100件（同一時間帯の番組は3件）までマイリストに登録できます。</dd></dl></div>');
                        } else if (showId =='js-mystar-confirm')  {
                            $(target).after('<div id="js-mystar-confirm" class="p-mystar p-mystar-fix p-mystar--confirm"><button class="p-mystar__close js-mystar-close"></button><p class="p-mystar__msg"><b>マイリストから削除してもよいですか？</b></p><div class="p-mystar__wbtn"><button class="p-mystar__btn js-confirm-btn" value="y">はい</button><button class="p-mystar__btn js-confirm-btn" value="n">いいえ</button></div></div>');
                        } else if (showId =='js-mystar-fail')  {
                            $(target).after('<div id="js-mystar-fail" class="p-mystar p-mystar-fix p-mystar--fail js-autohide"><button class="p-mystar__close-red js-mystar-close"></button><p class="p-mystar__msg"><b>削除できませんでした<br>再度お試しください。</b></p></div>');
                        }
                         

                    }
                    showEl = document.getElementById(showId);
                    
                } else {
                    showEl = document.getElementById('js-mystar-confirm')
                }
                /*this.showedElm = showEl;
                showEl.removeAttribute('style');
                fadeIn(showEl);
                this.overlay.classList.add('is-show');*/
                
                //this.overlay.classList.add('is-show');
                this.showedElm = showEl;
                showEl.removeAttribute('style');
                this.overlay.classList.add('is-show');
                setTimeout(function(){
                    
                    fadeIn(showEl);
                    
                    
                    $('#js-loading').removeClass('is-show');  
                },3000);
            }
        }
    }

    removeBaloon(e) {
        const removeTarget = e.target;
        
        const removeTargetClass = removeTarget.className;
        
    
        if(removeTargetClass.match(/p-mystar__btn/) && !removeTargetClass.match(/js-confirm-btn/)) {
            
        } else {
            if(this.showedElm  && !$('#js-loading').hasClass('is-show')) {
                fadeOut(this.showedElm);
                
                
                this.overlay.classList.remove('is-show');
                $(this.showedElm).remove();
                setTimeout(()=> {
                    $(this.showedElm).remove();
                    this.showedElm = null;
                    $('#j-container').removeClass('is-show-popup');
                }, 200);
                return true;
            }
        }
            

       
        return false;
    }


    getPos(el) {
        const rect = el.getBoundingClientRect();
        const pos = {top: rect.top, left: rect.left};
        return pos;
    }

}
